import type { BuildingInput } from "@/api/tracking";

const ADDRESS_ALIASES = ["address", "address1", "street", "street_address"];
const BIN_ALIASES = ["nyc_bin", "bin", "bins", "nyc bin"];

function normalizeHeader(header: string): string {
  return String(header || "").trim().toLowerCase().replace(/\s+/g, "_");
}

function findColumnIndex(headers: string[], aliases: string[]): number {
  for (let i = 0; i < headers.length; i++) {
    const norm = normalizeHeader(headers[i]);
    for (const alias of aliases) {
      if (norm === alias.replace(/\s+/g, "_") || norm === alias) {
        return i;
      }
    }
  }
  return -1;
}

function parseCSVLine(line: string): string[] {
  const result: string[] = [];
  let current = "";
  let inQuotes = false;
  for (let i = 0; i < line.length; i++) {
    const c = line[i];
    if (c === '"') {
      inQuotes = !inQuotes;
    } else if (c === "," && !inQuotes) {
      result.push(current.trim());
      current = "";
    } else {
      current += c;
    }
  }
  result.push(current.trim());
  return result;
}

function parseCSV(content: string): BuildingInput[] {
  const lines = content.split(/\r?\n/).filter((l) => l.trim());
  if (lines.length < 2) return [];

  const headers = parseCSVLine(lines[0]);
  const addrIdx = findColumnIndex(headers, ADDRESS_ALIASES);
  const binIdx = findColumnIndex(headers, BIN_ALIASES);

  if (addrIdx === -1 && binIdx === -1) return [];

  const buildings: BuildingInput[] = [];
  for (let i = 1; i < lines.length; i++) {
    const values = parseCSVLine(lines[i]);
    const address =
      addrIdx >= 0 ? (values[addrIdx] || "").trim() || undefined : undefined;
    const bin =
      binIdx >= 0 ? (values[binIdx] || "").trim() || undefined : undefined;
    if (!address && !bin) continue;
    buildings.push({ address, bin });
  }
  return buildings;
}

export async function parseTrackingFile(file: File): Promise<BuildingInput[]> {
  const name = (file.name || "").toLowerCase();
  if (name.endsWith(".csv")) {
    const text = await file.text();
    return parseCSV(text);
  }
  throw new Error("Unsupported file type. Use CSV.");
}
